import { HeaderButton } from "@omni/components/components/Navigation/Buttons/HeaderButton/headerButton";
import { HeaderButtonBaseProps } from "@omni/components/components/Navigation/Buttons/HeaderButton/headerButton.base";
import { cn } from "@omni/utils/styles";
import { ReactElement } from "react";

type Props = Omit<HeaderButtonBaseProps, "menuElement"> & {
    children?: ReactElement<{ closeCallback?: () => void }> | false | null;
};

export const HeaderButtonComponent = ({
    // HeaderButton props
    text,
    ariaLabel,
    hiddenText,
    icon,
    link,
    invert,
    invertMobile,
    showMenuOnHover,
    alerts,

    // HeaderButtonBase props
    hideChevron,
    withOverlay,
    iconPrefix,
    className,
    children
}: Props) => {
    return (
        <HeaderButton
            text={text}
            ariaLabel={ariaLabel}
            hiddenText={hiddenText}
            icon={icon}
            link={link}
            invert={invert}
            invertMobile={invertMobile}
            showMenuOnHover={showMenuOnHover}
            alerts={alerts}
            hideChevron={hideChevron}
            withOverlay={withOverlay}
            iconPrefix={iconPrefix}
            className={className}
            menuElement={children}
        >
            <HeaderButton.Trigger>
                <HeaderButton.Trigger.Icon>
                    <HeaderButton.Trigger.Icon.Alerts
                        className={cn("tw:text-white tw:bg-success")}
                    />
                </HeaderButton.Trigger.Icon>
                <HeaderButton.Trigger.Content />
                <HeaderButton.Trigger.Chevron />
            </HeaderButton.Trigger>
            <HeaderButton.Menu
                className={cn(
                    "tw:border tw:border-grey-light tw:shadow-xl tw:bg-background",
                    "tw:lg:rounded"
                )}
            />
        </HeaderButton>
    );
};
